import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

import Spinner from '@components/spinner'
import RenderField from '../Components/RenderField'
import '../Sidebar.sass'

class InvoicingEntity extends Component {
  static propTypes = {
    id: PropTypes.number,
    invoicingStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    modalStore: PropTypes.object,
    staticData: PropTypes.object
  }

  constructor (props) {
    super(props)
    const { invoicingStore, id } = props
    invoicingStore.getInvoicingEntityId(id)
  }

  renderLoader () {
    return <Spinner />
  }

  handleLinkClick = () => {
    const { sidebarStore, modalStore } = this.props
    sidebarStore.closeSidebar()
    // in case modal is open when clicking on link, close it
    modalStore.close()
  }

  renderClientContacts = contacts => {
    const { staticData } = this.props
    return contacts.map(contact => (
      <div key={contact.id} className='m-b-xxl'>
        <RenderField label='Name' value={contact.fullName} />
        <RenderField
          label='Office'
          value={
            <p
              className='sidebar-wrapper__content__link'
              onClick={this.handleLinkClick}
            >
              <NavLink to={`/office/${contact.client.office.id}`}>
                {contact.client.office.officeName}
              </NavLink>
            </p>
          }
        />
        <RenderField
          label='Phones'
          value={
            contact.address.phones.length > 0
              ? contact.address.phones.map(phone => (
                  <p key={phone.id}>
                    {`${phone.phoneNum} (${
                      staticData.names.phoneTypes[phone.phoneTypeId]
                    })`}
                  </p>
                ))
              : '-'
          }
        />
        <RenderField
          label='Emails'
          value={
            <div>
              {contact.email}
              {contact.address.emails.length > 0
                ? contact.address.emails.map(email => (
                    <p key={email.id}>{email.email}</p>
                  ))
                : null}
            </div>
          }
        />
        <RenderField
          label='Address'
          value={
            contact.address ? (
              <div>
                <p>{contact.address.address1}</p>
                <p>{contact.address.address2}</p>
                <p>
                  {contact.address.city} {contact.address.postalCode}
                </p>
                <p>{contact.address.state}</p>
                <p>{staticData.renderCountry(contact.address.countryId)}</p>
              </div>
            ) : (
              '-'
            )
          }
        />
        <RenderField
          label='Timezone'
          value={staticData.renderTimezone(contact.address.timezoneId)}
        />
      </div>
    ))
  }

  render () {
    const { singleEntity, loadingSingleEntity } = this.props.invoicingStore
    const { staticData } = this.props
    if (loadingSingleEntity) {
      return this.renderLoader()
    }

    const parentAccountLink = `/parent-account/${
      singleEntity.parentAccountId
    }/invoicing-entities/${singleEntity.id}`

    return (
      <div>
        <h1
          className='sidebar-wrapper__content__link'
          onClick={this.handleLinkClick}
        >
          <NavLink to={parentAccountLink}>{singleEntity.legalName}</NavLink>
        </h1>
        <RenderField label='GL code' value={singleEntity.glCode} />
        <RenderField label='Vat number' value={singleEntity.vatNumber || '-'} />
        <RenderField
          label='Invoicing region'
          value={singleEntity.invoicingRegion.name}
        />
        <RenderField
          label='Address'
          value={
            <div>
              <p>{singleEntity.address.address1}</p>
              <p>{singleEntity.address.address2}</p>
              <p>
                {singleEntity.address.city} {singleEntity.address.postalCode}
              </p>
              <p>{singleEntity.address.state}</p>
              <p>{staticData.renderCountry(singleEntity.address.countryId)}</p>
              <p>
                {staticData.renderTimezone(singleEntity.address.timezoneId)}
              </p>
            </div>
          }
        />
        <RenderField label='Comment' html={singleEntity.comment || '-'} />
        <h2 className='m-t-xl'>Accounting contacts information</h2>
        {singleEntity.contacts.length > 0
          ? this.renderClientContacts(singleEntity.contacts)
          : '-'}
      </div>
    )
  }
}

export default inject(
  'sidebarStore',
  'invoicingStore',
  'staticData',
  'modalStore'
)(observer(InvoicingEntity))
